import { ApiService } from '../services/api.service';
import PrintService from '../services/print.service';
import moment from 'moment';

moment.locale('ru');

// initial state
const state = {
    accountAddresses: [],
    accountAddressesLoading: false,
    accountData: {
        account_f_id: -1,
        account_address: '',
        account_number: -1,
        lastPaymentAmount: null,
        bills: [-1, -1],
        bill_year: -1,
        bill_month: -1,
        billPeriod: ''
    },
    accountSearchProccessing: false,
    billPDF: '',
    billForming: false
};

// getters
const getters = {
    accountAddresses01(state) {
        let end = state.accountAddresses.length >= 3 ? 3 : state.accountAddresses.length;
        return state.accountAddresses.slice(0, end);
    },
    accountAddresses02(state) {
        let end = state.accountAddresses.length >= 6 ? 6 : state.accountAddresses.length;
        return state.accountAddresses.slice(3, end);
    },
    accountAddresses03(state) {
        let end = state.accountAddresses.length >= 9 ? 9 : state.accountAddresses.length;
        return state.accountAddresses.slice(6, end);
    },
    billPDFFileName(state) {
        return state.billPDF ? `alseco_bill_${state.accountData.account_number}_${state.accountData.bill_year}-${state.accountData.bill_month}.pdf` : '';
    }
};

// actions
const actions = {
    init({ commit, state }) {
        if (state.accountAddresses.length > 0) {
            commit('setAccountAddresses', []);
        }
        if (state.accountData && state.accountData.account_f_id != -1) {
            commit('setBillForming', false);
            commit('setAccountData', {
                account_f_id: -1,
                account_address: '',
                account_number: -1,
                lastPaymentAmount: null,
                bills: [-1, -1],
                bill_year: -1,
                bill_month: -1,
                billPeriod: ''
            });
        }
    },
    async searchAddresses({ commit }, value) {
        try {
            commit('setAccountAddressesLoading', true);
            let data = await PrintService.searchAddress(value);
            commit('setAccountAddresses', data);
            return true;
        } catch (e) {
            return false;
        } finally {
            commit('setAccountAddressesLoading', false);
        }
    },
    async searchAccount({ commit }, value) {
        try {
            commit('setAccountSearchProccessing', true);
            let data = await PrintService.getAccountInfo(value);
            if (data) {
                if (data.__success) {
                    commit('setAccountData', data);
                    return 'OK';
                } else return data.__message;
            } else {
                return 'Ошибка';
            }
        } catch (e) {
            return e.message;
        } finally {
            commit('setAccountSearchProccessing', false);
        }
    },
    selectAccount({ commit }, value) {
        commit('setAccountData', value);
    },
    async loadBillPDFBase64({ commit, state }, recaptchaToken) {
        try {
            commit('setBillForming', true);
            let pdfData = await PrintService.getBillPDFAsBase64({
                accountId: state.accountData.account_number,
                billId: state.accountData.bills,
                year: state.accountData.bill_year,
                month: state.accountData.bill_month,
                recaptchaToken: recaptchaToken
            });
            commit('setBillPDF', pdfData);
        } catch (error) {
            throw error;
        } finally {
            commit('setBillForming', false);
        }
    },
    async loadBillPDF({ commit, state }, recaptchaToken) {
        try {
            commit('setBillForming', true);
            let pdfData = await PrintService.getBillPDF({
                accountId: state.accountData.account_number,
                billId: state.accountData.bills,
                year: state.accountData.bill_year,
                month: state.accountData.bill_month,
                recaptchaToken: recaptchaToken
            });
            commit('setBillPDF', pdfData);
        } catch (error) {
            throw error;
        } finally {
            commit('setBillForming', false);
        }
    },
    cancelAllRequests() {
        ApiService.cancelAll();
    },
    async checkLastPayment({ state }, recaptchaToken) {
        return await PrintService.checkLastPayment({
            accountFId: state.accountData.account_f_id,
            lastPaymentAmount: state.accountData.lastPaymentAmount,
            recaptchaToken
        });
    },
    async getAccountId({ commit, state }, { recaptchaToken }) {
        try {
            const data = await PrintService.getAccountId({
                accountFId: state.accountData.account_f_id,
                lastPaymentAmount: state.accountData.lastPaymentAmount,
                recaptchaToken: recaptchaToken
            });

            const newAccountData = {
                ...state.accountData
            };

            if (data && data.__success) {
                newAccountData.account_number = data.accountId;
                commit('setAccountData', newAccountData);
                return 'OK';
            }

            newAccountData.account_number = -1;
            commit('setAccountData', newAccountData);

            if (data && data.__success && !data.checkResult) {
                return 'Лицевой счёт не найден';
            }

            return data && data.__message ? data.__message : 'error';
        } catch (e) {
            return false;
        }
    }
};

// mutations
const mutations = {
    setAccountAddresses(state, data) {
        state.accountAddresses = data;
    },
    setAccountAddressesLoading(state, data) {
        state.accountAddressesLoading = data;
    },
    setAccountData(state, data) {
        let fullData = data;
        //months are 0 indexed.
        fullData.billPeriod = moment({
            year: data.bill_year,
            month: data.bill_month - 1,
            day: 1
        }).format('MMMM');
        state.accountData = fullData;
    },
    setAccountSearchProccessing(state, data) {
        state.accountSearchProccessing = data;
    },
    setBillPDF(state, data) {
        state.billPDF = data;
    },
    setBillForming(state, data) {
        state.billForming = data;
    }
};

export const print = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
